import * as React from "react";

import { Box, Button, Container, makeStyles, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { PermissionQuoteRead } from "../app/consts";
import { useAuth } from "swyft-react-core";

const useStyles = makeStyles(() => ({
  button: {
    width: "90%",
    maxWidth: "17.5rem"
  }
}));

const Home = () => {
  const classes = useStyles();
  const { isLoading, hasPermission } = useAuth();

  return (
    <Box minHeight="600px" my={4}>
      <Container maxWidth="lg">
        <Box display="flex" justifyContent="space-between" flexDirection="column" minHeight="200px" alignItems="center">
          <Typography variant="h1" paragraph>
            Swyft Store
          </Typography>

          {!isLoading && hasPermission(PermissionQuoteRead) && (
            <Button
              component={RouterLink}
              to="/quotes"
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              All Quotes
            </Button>
          )}

          <Button
            component={RouterLink}
            to="/my-quotes"
            variant="contained"
            color="secondary"
            className={classes.button}
          >
            My Quotes
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default connect()(Home);
